import { render, staticRenderFns } from "./RejectButton.vue?vue&type=template&id=142f1f0a"
import script from "./RejectButton.vue?vue&type=script&lang=ts"
export * from "./RejectButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports